const Lightning = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M16.3186 9.77104C16.299 9.68598 16.2584 9.60711 16.2005 9.54148C16.1427 9.47586 16.0694 9.42555 15.9872 9.39504L12.1696 8.80353L13.1372 3.13494C13.1595 3.02294 13.1451 2.90678 13.0962 2.80351C13.0473 2.70023 12.9665 2.61526 12.8655 2.56104C12.7635 2.50707 12.6465 2.48815 12.5326 2.50724C12.4188 2.52633 12.3144 2.58235 12.2359 2.66659L4.81262 10.5824C4.7518 10.6452 4.70779 10.7222 4.68463 10.8064C4.66147 10.8905 4.6599 10.9791 4.68006 11.064C4.70081 11.1486 4.74178 11.2269 4.79947 11.2924C4.85717 11.3578 4.92989 11.4085 5.01146 11.44L8.82912 12.0315L7.86145 17.7001C7.8392 17.8121 7.85357 17.9282 7.90248 18.0315C7.95138 18.1348 8.03224 18.2197 8.13319 18.274C8.20929 18.3122 8.29319 18.3325 8.37843 18.3333C8.45045 18.3336 8.52177 18.3191 8.58791 18.2908C8.65406 18.2624 8.71361 18.2207 8.76284 18.1684L16.1861 10.2526C16.2469 10.1898 16.2909 10.1128 16.3141 10.0286C16.3372 9.94451 16.3388 9.85594 16.3186 9.77104Z"
        fill={color}
      />
    </svg>
  )
}

export default Lightning
